export default {
  none: 'none',
  'shadown-inner': 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  'shadow-outline': '0 0 0 3px rgba(66, 153, 225, 0.5)',
  'shadow-100':
    '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  'shadow-200':
    '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  'shadow-300':
    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  'shadow-400':
    '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  'shadow-500': '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
};
